import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import PanelLayout from "@/components/PanelLayout";
import Dashboard from "@/pages/panel/Dashboard";
import AssistantHome from "@/pages/panel/AssistantHome";
import Inquiries from "@/pages/panel/Inquiries";
import Quotes from "@/pages/panel/Quotes";
import WorkOrders from "@/pages/panel/WorkOrders";
import Clients from "@/pages/panel/Clients";
import Materials from "@/pages/panel/Materials";
import CutOptimizer from "@/pages/panel/CutOptimizer";
import WhatsApp from "@/pages/panel/WhatsApp";
import Team from "@/pages/panel/Team";
import CompanyProfile from "@/pages/panel/CompanyProfile";
import Operario from "@/pages/Operario";
import PortonesIA from "@/pages/PortonesIA";

const getUser = () => JSON.parse(localStorage.getItem("gr_user") || "{}");

const ProtectedAdmin = ({ children }) => {
  const token = localStorage.getItem("gr_token");
  if (!token) return <Navigate to="/login" replace />;
  if (getUser().role === "operario") return <Navigate to="/operario" replace />;
  return children;
};

const ProtectedUser = ({ children }) => {
  const token = localStorage.getItem("gr_token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/portonesia" element={<ProtectedAdmin><PortonesIA /></ProtectedAdmin>} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/operario"
            element={
              <ProtectedUser>
                <Operario />
              </ProtectedUser>
            }
          />
          <Route
            path="/panel"
            element={
              <ProtectedAdmin>
                <PanelLayout />
              </ProtectedAdmin>
            }
          >
            <Route index element={<AssistantHome />} />
            <Route path="datos" element={<Dashboard />} />
            <Route path="consultas" element={<Inquiries />} />
            <Route path="cotizaciones" element={<Quotes />} />
            <Route path="ordenes" element={<WorkOrders />} />
            <Route path="clientes" element={<Clients />} />
            <Route path="materiales" element={<Materials />} />
            <Route path="optimizador" element={<CutOptimizer />} />
            <Route path="whatsapp" element={<WhatsApp />} />
            <Route path="equipo" element={<Team />} />
            <Route path="empresa" element={<CompanyProfile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
